import { APPLICATION_URL } from '../../constants';
import RemoteImage from '../common/remoteImage';
import RemoteText from '../common/remoteText';

function BankGuarantee() {
    return (
        <section className='bg-avenue-parchment-500 pt-24'>
            <div className='container relative mx-auto'>
                <RemoteImage
                    rel='preload'
                    name='HomeHeroImage'
                    alt='Bank guarantees reinvented'
                    outputAsImgTag='true'
                    className='absolute inset-0 hidden h-full w-full object-contain object-right pr-6 lg:block 2xl:object-none'
                />
                <div className='absolute inset-0 from-avenue-parchment-500 from-20% via-avenue-parchment-500 via-45% to-transparent to-60% lg:bg-gradient-to-r' />
                <RemoteImage
                    rel='preload'
                    name='HomeHeroImage'
                    alt='Bank guarantees reinvented'
                    outputAsImgTag='true'
                    className='h-full w-full object-cover object-center lg:hidden 2xl:object-none'
                />

                <div className='container relative mx-auto flex flex-col items-center px-6 py-12 lg:flex-row lg:justify-between lg:px-3 lg:py-24'>
                    <div className='space-y-6 lg:w-1/2'>
                        <h1 className='text-5xl text-avenue-slate-500 md:block md:max-w-xl md:text-6xl'>
                            <RemoteText name='HomeTopBannerHeadLine' />
                        </h1>
                        <p className='my-auto text-3xl text-avenue-slate-500'>
                            <RemoteText name='HomeTopBannerBlurb' />
                        </p>
                        <div className='flex flex-col items-start lg:flex-row lg:items-center'>
                            <a
                                id='apply-now-btn'
                                href={APPLICATION_URL}
                                type='button'
                                className='max-width:100px display:block mt-6 whitespace-nowrap rounded-md bg-avenue-orange-500 px-8 py-4 text-lg font-bold tracking-normal text-white shadow-md transition delay-150 duration-300 ease-in-out hover:-translate-y-1 hover:scale-110'
                                aria-label='Get started '
                                target='_self'
                                rel='noreferrer'
                            >
                                Apply Now
                                <span className='tracking-normal text-white'> →</span>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default BankGuarantee;
